import { connect } from "react-redux";

import {
    clearAttachmentErrorLog,
    navigateByBindingPathsOrHighlanderPathActionCreator,
    navigateToAttachment,
} from "../../../../Engine/ActionCreators/ErrorLogActionCreators";
import {
    switchOffErrorsLogTooltip,
    switchOffErrorsLogTooltipAttachment,
    switchOnErrorsLogTooltip,
} from "../../../../Engine/ActionCreators/ErrorLogTooltipActionCreators";
import { BindingPath } from "../../../../Engine/Core/CoreTypes";
import { CandyDispatch } from "../../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";

import { ErrorsList } from "./ErrorsList";

const mapStateToProps = (state: FullFormState) => ({
    tooltipErrorId: state.errorLogTooltip?.errorId,
    tooltipBindingPath: state.errorLogTooltip?.bindingPaths,
    tooltipAttachment: state.errorLogTooltipAttachment,
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    onFindAndFocusControl: (attachmentId?: string) =>
        dispatch(navigateByBindingPathsOrHighlanderPathActionCreator(attachmentId)),
    disableControlsTooltip: (bindingPaths: BindingPath[], errorId: string) =>
        dispatch(switchOnErrorsLogTooltip(bindingPaths, errorId)),
    enableControlsTooltip: () => dispatch(switchOffErrorsLogTooltip()),
    onNavigateToAttachment: (attachmentId: string, highlanderPath: string) =>
        dispatch(navigateToAttachment(attachmentId, highlanderPath)),
    clearAttachmentErrorLog: () => dispatch(clearAttachmentErrorLog()),
    enableControlsTooltipAttachment: () => dispatch(switchOffErrorsLogTooltipAttachment()),
});

export const ErrorsListContainer = connect(mapStateToProps, mapDispatchToProps)(ErrorsList);
